import { render, staticRenderFns } from "./TaskSubtaskForm.vue?vue&type=template&id=f8179894&"
import script from "./TaskSubtaskForm.vue?vue&type=script&lang=js&"
export * from "./TaskSubtaskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports